import React from 'react';
import ComponentWrapper from './ComponentWrapper';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';
import LoCoPilot from './components/LoCoPilot';

const RoutesConfig = [
  { path: "/", element: <ComponentWrapper component={LoCoPilot} componentName="LoCoPilot" componentPath="src/components/LoCoPilot.js" /> },
  { path: "/locopilot", element: <ComponentWrapper component={LoCoPilot} componentName="LoCoPilot" componentPath="src/components/LoCoPilot.js" /> },
  { path: "/contact", element: <ComponentWrapper component={Contact} componentName="Contact" componentPath="src/components/Contact.js" /> },
  { path: "/privacy-policy", element: <ComponentWrapper component={PrivacyPolicy} componentName="PrivacyPolicy" componentPath="src/components/PrivacyPolicy.js" /> },
];

export default RoutesConfig;
